module.exports = __webpack_public_path__ + "RMR PKG Enrollment Guide.pdf";